import { render, staticRenderFns } from "./custConvertRealList.vue?vue&type=template&id=ba130db6&scoped=true"
import script from "./custConvertRealList.vue?vue&type=script&lang=js"
export * from "./custConvertRealList.vue?vue&type=script&lang=js"
import style0 from "./custConvertRealList.vue?vue&type=style&index=0&id=ba130db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba130db6",
  null
  
)

export default component.exports